import { type PropsWithChildren, createContext, useContext } from "react";

type SectionSettings = Record<string, unknown>;

const SectionSettingsContext = createContext<SectionSettings>({});

type Props = {
  value: SectionSettings;
};

function SectionSettingsProvider({
  children,
  value,
}: PropsWithChildren<Props>) {
  return (
    <SectionSettingsContext.Provider value={value}>
      {children}
    </SectionSettingsContext.Provider>
  );
}

function useSectionSettings<
  T extends SectionSettings = Record<string, unknown>
>() {
  // @ts-expect-error TODO: fix this
  const context = useContext<T>(SectionSettingsContext);

  if (context === undefined) {
    throw new Error(
      "useSectionSettings must be used within a SectionSettingsProvider"
    );
  }

  return context;
}

export { SectionSettingsProvider, useSectionSettings };
